import {
  attractionCategoryCrudConfig,
  type AttractionCategory,
} from '@/config/objects/attraction-categories';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Attraction Category create/edit form page
 */
export function AttractionCategoryFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // If id is 'new', treat as create mode (id = undefined)
  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  /**
   * Handle successful form submission
   */
  const handleSuccess = (attractionCategory: AttractionCategory) => {
    // Navigate to the attraction category detail page
    navigate(`/attraction-categories/${attractionCategory.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Attraction Categories', href: '/attraction-categories' },
        { label: 'Attraction Category', href: `/attraction-categories/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Attraction Categories', href: '/attraction-categories' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={attractionCategoryCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
